import React, { useEffect, useState } from 'react';
import { Icon, Modal, Button } from '../ui';
import { operationalKeys } from './navigation';
import { readPreference, writePreference } from './workspace';
import './workspace.css';
const pageIcons = {
  overview: 'clock',
  planner: 'calendar',
  loadingBayPlanner: 'calendar',
  jobs: 'briefcase',
  vehicles: 'truck',
  drivers: 'users',
  websiteUsers: 'users',
  layoutEditor: 'map',
  general: 'settings',
  license: 'shield',
  displayLayout: 'monitor',
  gates: 'gate',
  loadingBays: 'box',
  vehicleClasses: 'truck'
};
export default function WorkspaceShell({
  sections,
  page,
  onNavigate,
  boardName,
  logoUrl,
  user,
  themeMode,
  onTheme,
  onLogout,
  onHelp,
  children,
  collapsed,
  onCollapse
}) {
  const [drawer, setDrawer] = useState(false),
    [command, setCommand] = useState(false),
    [query, setQuery] = useState('');
  const [pins, setPins] = useState(() => readPreference('pins', []));
  const pages = sections.flatMap(s => s.pages),
    current = pages.find(p => p.key === page);
  const admin = sections.filter(s => s.title !== 'Arbeitsbereich');
  const adminPages = admin.flatMap(s => s.pages),
    isAdmin = adminPages.some(p => p.key === page);
  useEffect(() => {
    const key = e => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setCommand(x => !x);
        setQuery('');
      }
      if (e.key === 'Escape') setDrawer(false);
    };
    window.addEventListener('keydown', key);
    return () => window.removeEventListener('keydown', key);
  }, []);
  const go = async key => {
    const accepted = await onNavigate(key);
    if (accepted !== false) {
      setDrawer(false);
      setCommand(false);
    }
  };
  const togglePin = key => setPins(old => {
    const next = old.includes(key) ? old.filter(x => x !== key) : [...old, key];
    writePreference('pins', next);
    return next;
  });
  const item = p => <button key={p.key} className={'ws-nav-item ' + (page === p.key ? 'selected' : '')} aria-current={page === p.key ? 'page' : undefined} title={p.label} onClick={() => go(p.key)}><Icon name={pageIcons[p.key] || 'box'} /><span>{p.label}</span></button>;
  return <div className={'workspace ' + (collapsed ? 'is-collapsed ' : '') + (drawer ? 'drawer-open' : '')}>
  {drawer && <button className="ws-scrim" aria-label="Navigation schließen" onClick={() => setDrawer(false)} />}
  <aside className="ws-sidebar" aria-label="Hauptnavigation">
   <div className="ws-brand">{logoUrl ? <img src={logoUrl} alt="" /> : <span className="ws-brand-mark">D</span>}<div><strong>DispoBoard</strong><small>{boardName || 'Arbeitsbereich'}</small></div><button className="ws-collapse" onClick={onCollapse} title="Navigation ein-/ausklappen" aria-label="Navigation ein-/ausklappen"><Icon name="panel" /></button></div>
   <button className="ws-search" onClick={() => {
        setCommand(true);
        setQuery('');
      }} title="Schnellnavigation (Strg+K)"><Icon name="search" /><span>Seite finden</span><kbd>Ctrl K</kbd></button>
   <nav className="ws-nav"><small className="ws-caption">ARBEITSBEREICH</small>{pages.filter(p => operationalKeys.includes(p.key) || p.key === 'loadingBayPlanner').map(item)}
    {pins.some(key => adminPages.some(p => p.key === key)) && <><small className="ws-caption">ANGEHEFTET</small>{adminPages.filter(p => pins.includes(p.key)).map(item)}</>}
   </nav>
   <div className="ws-sidebar-bottom">{adminPages.length > 0 && <button className={'ws-nav-item ' + (isAdmin ? 'selected' : '')} title="Verwaltung" onClick={() => go(isAdmin ? page : adminPages[0].key)}><Icon name="settings" /><span>Verwaltung</span></button>}<button className="ws-nav-item" title="Hilfe" onClick={onHelp}><Icon name="help" /><span>Hilfe</span></button>
    <div className="ws-profile"><span className="ws-avatar">{user.username?.slice(0, 1).toUpperCase()}</span><div><strong>{user.username}</strong><small>{user.permissions?.adminUser ? 'Administrator' : 'Teammitglied'}</small></div><button title="Abmelden" aria-label="Abmelden" onClick={onLogout}><Icon name="logout" /></button></div>
   </div>
  </aside>
  <div className="ws-main"><header className="ws-topbar"><button className="ws-menu" aria-label="Navigation öffnen" onClick={() => setDrawer(true)}><Icon name="menu" /></button><div className="ws-breadcrumb">{isAdmin && <><span>Verwaltung</span><span>/</span></>}<strong>{current?.label || 'DispoBoard'}</strong></div><div className="ws-top-actions"><span className="ws-date">{new Date().toLocaleDateString('de-DE', {
              weekday: 'short',
              day: 'numeric',
              month: 'long'
            })}</span><button aria-label={themeMode === 'dark' ? 'Light Mode' : 'Dark Mode'} title={themeMode === 'dark' ? 'Light Mode' : 'Dark Mode'} onClick={() => onTheme(themeMode === 'dark' ? 'light' : 'dark')}><Icon name={themeMode === 'dark' ? 'sun' : 'moon'} /></button><button aria-label="Schnellnavigation" onClick={() => setCommand(true)}><Icon name="search" /></button></div></header>
   <div className={'ws-body ' + (isAdmin ? 'with-admin' : '')}>
    {isAdmin && <nav className="ws-admin" aria-label="Verwaltung">{admin.map(group => <section key={group.title}><h2>{group.title}</h2>{group.pages.map(p => <div className="ws-admin-row" key={p.key}>{item(p)}<button className={'ws-pin ' + (pins.includes(p.key) ? 'pinned' : '')} onClick={() => togglePin(p.key)} title={pins.includes(p.key) ? 'Lösen' : 'Anheften'} aria-label={p.label + (pins.includes(p.key) ? ' lösen' : ' anheften')} aria-pressed={pins.includes(p.key)}><Icon name="pin" size={14} /></button></div>)}</section>)}</nav>}
    <main id="workspace-content" className="ws-content" key={page}>{children}</main>
   </div>
  </div>
  {command && <Modal title="Schnellnavigation" onClose={() => setCommand(false)}><input className="ui-search ws-command-input" autoFocus aria-label="Seiten suchen" placeholder="Seite suchen …" value={query} onChange={e => setQuery(e.target.value)} /><div className="ws-command-results">{pages.filter(p => p.label.toLocaleLowerCase().includes(query.toLocaleLowerCase())).map(p => <Button key={p.key} onClick={() => go(p.key)}><Icon name={pageIcons[p.key] || 'box'} />{p.label}<small>{p.area === 'admin' ? 'Verwaltung' : 'Arbeitsbereich'}</small></Button>)}</div></Modal>}
 </div>;
}
